import FormGroup from "./FormGroup";
import { emailFix, phoneNumFix, providerType } from "../../utils/UtilsFunc";
import React, { useEffect, useState } from "react";
import "./UserInfo.css";
import { useApi } from "../../hooks/ApiProvider";
import { useMembership } from "../../hooks/MembershipProvider/MembershipProvider";

const UserInfo = (props: any) => {
  console.log(props, "/[userinfo.tsx]");
  const { userInfo, onSubmit } = props;

  const {
    saveProfileName,
    saveProfileCalledName,
    saveAgreeMarketingInformation,
  } = useApi();
  const { updateUser } = useMembership();
  const [userEditInfo, setUserEditInfo] = useState<any>({});

  const [isMarketingAgreed, setIsMarketingAgreed] = useState(
    Boolean(userInfo?.agree_marketing_information)
  );
  const [actType, setActType] = useState(`view`);
  //
  // const [editName, setEditName] = useState(false);
  // const [nameValue, setNameValue] = useState(userInfo?.name || '');
  //
  // const [editCalledName, setEditCalledName] = useState(false);
  // const [calledNameValue, setCalledNameValue] = useState(userInfo?.calledName || '');
  //
  useEffect(() => {
    setIsMarketingAgreed(Boolean(userInfo?.agree_marketing_information));
  }, [userInfo]);
  //
  // // 마케팅 수신 동의 변경 핸들러
  const handleMarketingChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsMarketingAgreed(e.target.checked);
    if (onSubmit) {
      saveAgreeMarketingInformation?.(e.target.checked)
        .then(() => {
          onSubmit({ agree_marketing_information: e.target.checked });
          updateUser({ agree_marketing_information: e.target.checked });
        })
        .catch((error) => {
          console.error("마케팅 정보 동의 저장 실패:", error);
        });
    }
  };
  //
  // // 이름 수정 핸들러
  // const handleNameEdit = () => {
  //   setEditName(true);
  // };
  // const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   setNameValue(e.target.value);
  // };
  // const handleNameSave = () => {
  //   if (onSubmit) {
  //     saveProfileName(nameValue).then(() => {
  //       onSubmit({ name: nameValue });
  //       updateUser({ name: nameValue });
  //     });
  //   }
  //   setEditName(false);
  // };
  //
  // // 호출 이름 수정 핸들러
  // const handleCalledNameEdit = () => {
  //   setEditCalledName(true);
  // };
  // const handleCalledNameSave = () => {
  //   if (onSubmit) {
  //     saveProfileCalledName(calledNameValue).then(() => {
  //       onSubmit({ calledName: calledNameValue });
  //       updateUser({ calledName: calledNameValue });
  //     });
  //   }
  //   setEditCalledName(false);
  // };
  // const handleCalledNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   setCalledNameValue(e.target.value);
  // };
  //
  const handleValueChange = (e: any) => {
    const { name, value } = e.target;
    console.log(name, value);
    // console.log(name)
    if (name === `calledName`) {
      setUserEditInfo({
        ...userEditInfo,
        calledName: value,
      });
    }
    if (name === `name`) {
      setUserEditInfo({
        ...userEditInfo,
        name: value,
      });
    }
  };

  const editUserInfo = async (type: string) => {
    console.log(userEditInfo?.name, userEditInfo?.calledName);
    if (type === `view`) {
      saveProfileName(userEditInfo?.name).then(() => {
        onSubmit({ name: userEditInfo?.name });
        updateUser({ name: userEditInfo?.name });
      });
      saveProfileCalledName(userEditInfo?.calledName).then(() => {
        onSubmit({ calledName: userEditInfo?.calledName });
        updateUser({ calledName: userEditInfo?.calledName });
      });
    }
    setActType(type);
  };
  useEffect(() => {
    setUserEditInfo(userInfo);
  }, [userInfo]);

  console.log(userInfo);

  // useEffect(() => {
  //   setNameValue(userInfo?.name || '');
  //   setCalledNameValue(userInfo?.calledName || '');
  // }, [userInfo]);

  return (
    <>
      <div className={`sec sec_1`}>
        <h3 className={`tit h3`}>내 정보</h3>
        <div className={`card_layout`}>
          <div className={`card_sec`}>
            {/**---------------------지은이------------------**/}
            <FormGroup>
              <FormGroup.Label className={`icons tip`}>
                지은이
                <div className={`tooltip`}>
                  가입한 회원이 인터뷰 대상자가 아닌 경우,
                  <br />
                  실제 인터뷰 대상자의 성함을 작성해주세요.
                </div>
              </FormGroup.Label>
              <FormGroup.Value>
                {actType === `view` ? (
                  <button
                    className={`btn_edit`}
                    onClick={() => editUserInfo(`edit`)}
                  >
                    {userEditInfo?.calledName || "지은이"}
                  </button>
                ) : (
                  <>
                    <input
                      type="text"
                      name={`calledName`}
                      value={userEditInfo?.calledName}
                      onChange={handleValueChange}
                      className={`form_control`}
                    />
                  </>
                )}
                {/*{!editCalledName ? (*/}
                {/*  <button className={`btn_edit`} onClick={handleCalledNameEdit}>*/}
                {/*    {userInfo?.calledName || '지은이'}*/}
                {/*  </button>*/}
                {/*) : (*/}
                {/*  <div className="edit_wrap">*/}
                {/*    <input */}
                {/*      type="text" */}
                {/*      value={calledNameValue}*/}
                {/*      onChange={handleCalledNameChange}*/}
                {/*      onKeyDown={(e) => {*/}
                {/*        if (e.key === 'Enter') {*/}
                {/*          handleCalledNameSave();*/}
                {/*        }*/}
                {/*      }}*/}
                {/*      className={`form_control`}*/}
                {/*    />*/}
                {/*    <button */}
                {/*      className="btn_save" */}
                {/*      onClick={handleCalledNameSave}*/}
                {/*    >*/}
                {/*      저장*/}
                {/*    </button>*/}
                {/*  </div>*/}
                {/*)}*/}
              </FormGroup.Value>
            </FormGroup>
            {/**---------------------이름--------------------**/}
            <FormGroup>
              <FormGroup.Label>이름</FormGroup.Label>
              <FormGroup.Value>
                {actType === `view` ? (
                  <button
                    className={`btn_edit`}
                    onClick={() => editUserInfo(`edit`)}
                  >
                    {userEditInfo?.name || "지은이"}
                  </button>
                ) : (
                  <>
                    <input
                      type="text"
                      name={`name`}
                      value={userEditInfo?.name}
                      onChange={handleValueChange}
                      className={`form_control`}
                    />
                  </>
                )}
                {/*{!editName ? (*/}
                {/*  <button className={`btn_edit`} onClick={handleNameEdit}>*/}
                {/*    {userInfo?.name}*/}
                {/*  </button>*/}
                {/*) : (*/}
                {/*  <div className="edit_wrap">*/}
                {/*    <input */}
                {/*      type="text" */}
                {/*      value={nameValue}*/}
                {/*      onChange={handleNameChange}*/}
                {/*      onKeyDown={(e) => {*/}
                {/*        if (e.key === 'Enter') {*/}
                {/*          handleNameSave();*/}
                {/*        }*/}
                {/*      }}*/}
                {/*      className={`form_control p-1`}*/}
                {/*    />*/}
                {/*    <button className="btn_save" onClick={handleNameSave}>저장</button>*/}
                {/*  </div>*/}
                {/*)}*/}
              </FormGroup.Value>
            </FormGroup>
            {/**---------------휴대폰 번호--------------------**/}
            <FormGroup>
              <FormGroup.Label>휴대폰 번호</FormGroup.Label>
              <FormGroup.Value>
                <button className={`btn_edit_none`}>
                  {phoneNumFix(userInfo?.phone_number)}
                </button>
              </FormGroup.Value>
            </FormGroup>
            {/**---------------마케팅 수신 동의----------------**/}
            <FormGroup>
              <FormGroup.Label>마케팅 수신 동의</FormGroup.Label>
              <FormGroup.Value>
                <label className={`btn_switch`}>
                  <input
                    type="checkbox"
                    checked={isMarketingAgreed}
                    onChange={handleMarketingChange}
                  />
                  <span className="slider round"></span>
                </label>
              </FormGroup.Value>
            </FormGroup>
          </div>
          <div className={`card_sec`}>
            {/**---------------가입 이메일--------------------**/}
            <FormGroup>
              <FormGroup.Label>가입 이메일</FormGroup.Label>
              <FormGroup.Value>{emailFix(userInfo?.email)}</FormGroup.Value>
            </FormGroup>
            {/**---------------가입 경로----------------------**/}
            <FormGroup>
              <FormGroup.Label>가입 경로</FormGroup.Label>
              <FormGroup.Value className={`${userInfo?.provider} icons`}>
                {providerType(userInfo?.provider)?.name}
              </FormGroup.Value>
            </FormGroup>
          </div>
        </div>
        <div className="sec btn_group flex justify-center">
          {actType === `view` && (
            <button className={`btn`} onClick={() => editUserInfo(`edit`)}>
              회원정보 수정
            </button>
          )}
          {actType === `edit` && (
            <button className={`btn`} onClick={() => editUserInfo(`view`)}>
              내용저장
            </button>
          )}
        </div>
      </div>
    </>
  );
};
export default UserInfo;
